export default "__VITE_ASSET__BKRQGoXy__"